import { render, staticRenderFns } from "./DonationReport.vue?vue&type=template&id=126176aa&scoped=true"
import script from "./DonationReport.vue?vue&type=script&lang=js"
export * from "./DonationReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126176aa",
  null
  
)

export default component.exports